import { ContextStore } from '../../../react-core/Flux/Variables';
import { RoutesHelper } from '../../../react-core/Utils/RoutesHelper';
import { AjaxWrapper } from '../../../react-core/Async/AjaxWrapper';
import { Promise } from '../../../react-core/Async/Promise';
import { DisinvestmentStrategyTypeModel } from '../../Models/Domains/Instructions/DisinvestmentStrategyTypeModel';

declare var IS_RUNNING_IN_APP_POOL;

export class DisinvestmentStrategyClient {
  private _culture: string;

  public constructor() {
    var contextStoreState = ContextStore.getContext();
    this._culture = contextStoreState.culture;
  }

  public get(instructionId: string): Promise<DisinvestmentStrategyTypeModel, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Instruction/DisinvestmentStrategy/Get';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { instructionId: instructionId }

    return AjaxWrapper.get<DisinvestmentStrategyTypeModel, any>(url, data);
  }
}

